  import { defineComponent, type PropType } from "vue";
  import CiviliteSelect from '@/extend/controls/civilite/CiviliteSelect';
  import EmploiSelect from '@/extend/controls/emploi/EmploiSelect';
  import PaysSelect from '@/extend/controls/pays/PaysSelect';
  import PaysSelectNat from '@/extend/controls/pays/PaysSelectNat';
  import SalarieAbattement from '@/extend/controls/salarie/SalarieAbattement';
  import SalarieAvatar from '@/extend/controls/salarie/SalarieAvatar';
  import SalarieDateHandicap from '@/extend/controls/salarie/SalarieDateHandicap';
  import { Period } from '@/framework/base/helpers/DateFormat';
  import SalarieDateNaissance from '@/extend/controls/salarie/SalarieDateNaissance';
  import SalarieDepartementNaissance from '@/extend/controls/salarie/SalarieDepartementNaissance';
  import SalarieFiscalite from '@/extend/controls/salarie/SalarieFiscalite';
  import SalarieIdentifiant from '@/extend/controls/salarie/SalarieIdentifiant';
  import SalarieMail from '@/extend/controls/salarie/SalarieMail';
  import SalarieNom from '@/extend/controls/salarie/SalarieNom';
  import SalarieNomNaissance from '@/extend/controls/salarie/SalarieNomNaissance';
  import SalarieNumero from '@/extend/controls/salarie/SalarieNumero';
  import SalarieNumeroCongeSpec from '@/extend/controls/salarie/SalarieNumeroCongeSpec';
  import SalarieNumeroSecu from '@/extend/controls/salarie/SalarieNumeroSecu';
  import SalariePrenom from '@/extend/controls/salarie/SalariePrenom';
  import SalariePseudo from '@/extend/controls/salarie/SalariePseudo';
  import SalarieStatutHandicap from '@/extend/controls/salarie/SalarieStatutHandicap';
  import SalarieVilleNaissance from '@/extend/controls/salarie/SalarieVilleNaissance';
  import Salarie from '@/extend/classes/Salarie';
  import { FieldStatus, EditFieldTheme, SectionStatus } from '@/framework/base/components/FieldInfo';
  import { Alerts } from '@/framework/base/helpers/Alerts'; 
  import { storeSalarie } from '@/generated/stores';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import { Extended } from '@/framework/base/classes/Schema';
  import ButtonPlus from '@/framework/base/components/ButtonPlus.vue';
  import Route from '@/generated/classes/Route';
  import { Fiches, Sections } from '@/generated/classes/AppSchema';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  export default defineComponent({
    components: {
      SectionHeader,
      LoaderButton,
      ButtonPlus,
      CiviliteSelect,
      EmploiSelect,
      PaysSelect,
      PaysSelectNat,
      SalarieAbattement,
      SalarieAvatar,
      SalarieDateHandicap,
      SalarieDateNaissance,
      SalarieDepartementNaissance,
      SalarieFiscalite,
      SalarieIdentifiant,
      SalarieMail,
      SalarieNom,
      SalarieNomNaissance,
      SalarieNumero,
      SalarieNumeroCongeSpec,
      SalarieNumeroSecu,
      SalariePrenom,
      SalariePseudo,
      SalarieStatutHandicap,
      SalarieVilleNaissance,
    },

    props: {
      salarie: {
        type: Object as PropType<Salarie>,
        required: true
      },
      showButton: {
        type: Boolean,
      },
      autoSave: {
        type: Boolean,
      },
      fieldOnly: {
        type: Boolean,
      },
      extended: {
        type: Boolean,
      },
      autoClear: {
        type: Boolean,
      },
      dialog: {
        type: Boolean,
      },
      closeSection: {
        type: Boolean,
      },
      showMissing: {
        type: Boolean,
      },
      moduleId: {
        type: Number,
      },
      theme: {
        type: Object as PropType<EditFieldTheme>,
      },
      fiche: {
        type: String,
      },
      fromSection: {
        type: String,
      },
      requiredAttributs: {
        type: Array as PropType<string[]>,
      },
      toggleResetCiviliteSelect: {
        type: Boolean
      },
      toggleResetEmploiSelect: {
        type: Boolean
      },
      toggleResetPaysSelect: {
        type: Boolean
      },
      toggleResetPaysSelectNat: {
        type: Boolean
      },
    },

    beforeUnmount (): void {
      if (!this.closeSection) {
        this.beforeClose();
      }
    },

    data() {
      return {
    toggleCiviliteId: false,
        civiliteIdStatus: new FieldStatus(false, false, 0),
        strCiviliteId: '',
    toggleEmploiId: false,
        emploiIdStatus: new FieldStatus(false, false, 0),
        strEmploiId: '',
    togglePaysNaissanceId: false,
        paysNaissanceIdStatus: new FieldStatus(false, false, 0),
        strPaysNaissanceId: '',
    togglePaysNationaliteId: false,
        paysNationaliteIdStatus: new FieldStatus(false, false, 0),
        strPaysNationaliteId: '',
        abattementStatus: new FieldStatus(false, false, 0),
        strAbattement: '',
        avatarStatus: new FieldStatus(false, false, 0),
        strAvatar: '',
        dateHandicapStatus: new FieldStatus(false, false, 0),
        strDateHandicap: '',
        dateNaissanceStatus: new FieldStatus(false, false, 0),
        strDateNaissance: '',
        departementNaissanceStatus: new FieldStatus(false, false, 0),
        strDepartementNaissance: '',
        fiscaliteStatus: new FieldStatus(false, false, 0),
        strFiscalite: '',
        identifiantStatus: new FieldStatus(false, false, 0),
        strIdentifiant: '',
        mailStatus: new FieldStatus(false, false, 0),
        strMail: '',
        nomStatus: new FieldStatus(false, false, 0),
        strNom: '',
        nomNaissanceStatus: new FieldStatus(false, false, 0),
        strNomNaissance: '',
        numeroStatus: new FieldStatus(false, false, 0),
        strNumero: '',
        numeroCongeSpecStatus: new FieldStatus(false, false, 0),
        strNumeroCongeSpec: '',
        numeroSecuStatus: new FieldStatus(false, false, 0),
        strNumeroSecu: '',
        prenomStatus: new FieldStatus(false, false, 0),
        strPrenom: '',
        pseudoStatus: new FieldStatus(false, false, 0),
        strPseudo: '',
        statutHandicapStatus: new FieldStatus(false, false, 0),
        strStatutHandicap: '',
        villeNaissanceStatus: new FieldStatus(false, false, 0),
        strVilleNaissance: '',
        refSalarie: new Salarie,
        cloneSalarie: new Salarie,
      salarieSaving: false,
        saving: false,
        restoring: false,
        inDialog: false,
        updated: false,
        error: false,
        saveLoading: false,
        saveFailed: false,
        allowClearRef: true,
        objType: ObjTypes.SALARIE,
        status: new SectionStatus(false, false, false),
        autoClose: true,
        closing: false
      }
    },
    computed: {
      isExtended (): boolean {
        return this.extended;
      },

      exist (): boolean {
        return this.editSalarie.id != 0
      },

      extendIcon (): string {
        return this.extended ? 'fas fa-circle-minus' : 'fas fa-circle-plus';
      },

      saveButton (): boolean {
        return (this.showButton == undefined || this.showButton == true) && !this.allReadOnly;
      },

      editSalarie: {
        get(): Salarie {
          if (this.closeSection) {
            this.beforeClose();
          } else {
            if (this.salarie != undefined) {
              if (this.salarie.id == 0) {
                Alerts.debug('CrudSalarie : les objets passés en paramètre doivent être issus du store (id <> 0)');
              }
              if (this.cloneSalarie.id != this.salarie.id && !this.saving) {
                this.handleSalarieChange();
              }
            }
          }
          return this.refSalarie;
        },
        set(value: Salarie) {
          this.refSalarie = value;
        }
      },

      canCreate (): boolean {
        return this.refSalarie.id > 0;
      },

      canDelete (): boolean {
        return this.refSalarie.canDelete && this.refSalarie.id > 0;
      },

      updatedAndValid (): boolean {
        return this.updated && !this.error;
      },

      clearAuto (): boolean {
        return (this.autoClear == undefined || this.autoClear == true) && this.allowClearRef;
      },

    resetCiviliteId (): boolean {
      return this.toggleCiviliteId
    },

      civiliteId: {
        get(): number {
          return this.editSalarie.civiliteId;
        },
        set(value: number) {
          this.editSalarie.civiliteId = value;
          this.fieldUpdated('CIVILITE_ID', value);
        }
      },

    resetEmploiId (): boolean {
      return this.toggleEmploiId
    },

      emploiId: {
        get(): number {
          return this.editSalarie.emploiId;
        },
        set(value: number) {
          this.editSalarie.emploiId = value;
          this.fieldUpdated('EMPLOI_ID', value);
        }
      },

    resetPaysNaissanceId (): boolean {
      return this.togglePaysNaissanceId
    },

      paysNaissanceId: {
        get(): number {
          return this.editSalarie.paysNaissanceId;
        },
        set(value: number) {
          this.editSalarie.paysNaissanceId = value;
          this.fieldUpdated('PAYS_NAISSANCE_ID', value);
        }
      },

    resetPaysNationaliteId (): boolean {
      return this.togglePaysNationaliteId
    },

      paysNationaliteId: {
        get(): number {
          return this.editSalarie.paysNationaliteId;
        },
        set(value: number) {
          this.editSalarie.paysNationaliteId = value;
          this.fieldUpdated('PAYS_NATIONALITE_ID', value);
        }
      },


      abattement: {
        get(): boolean | null {
          return this.editSalarie.abattement;
        },
        set(value: boolean | null) {
          this.editSalarie.abattement = value;
          this.fieldUpdated('ABATTEMENT', value);
        }
      },


      avatar: {
        get(): string {
          return this.editSalarie.avatar;
        },
        set(value: string) {
          this.editSalarie.avatar = value;
          this.fieldUpdated('AVATAR', value);
        }
      },


      dateHandicap: {
        get(): Date | null {
          return this.editSalarie.dateHandicap;
        },
        set(value: Date | null) {
          this.editSalarie.dateHandicap = value;
          this.fieldUpdated('DATE_HANDICAP', value);
        }
      },

      periodDateHandicap() : Period[] {
        return []
      },

      dateNaissance: {
        get(): Date | null {
          return this.editSalarie.dateNaissance;
        },
        set(value: Date | null) {
          this.editSalarie.dateNaissance = value;
          this.fieldUpdated('DATE_NAISSANCE', value);
        }
      },

      periodDateNaissance() : Period[] {
        return []
      },

      departementNaissance: {
        get(): string {
          return this.editSalarie.departementNaissance;
        },
        set(value: string) {
          this.editSalarie.departementNaissance = value;
          this.fieldUpdated('DEPARTEMENT_NAISSANCE', value);
        }
      },


      fiscalite: {
        get(): number {
          return this.editSalarie.fiscalite;
        },
        set(value: number) {
          this.editSalarie.fiscalite = value;
          this.fieldUpdated('FISCALITE', value);
        }
      },


      identifiant: {
        get(): string {
          return this.editSalarie.identifiant;
        },
        set(value: string) {
          this.editSalarie.identifiant = value;
          this.fieldUpdated('IDENTIFIANT', value);
        }
      },


      mail: {
        get(): string {
          return this.editSalarie.mail;
        },
        set(value: string) {
          this.editSalarie.mail = value;
          this.fieldUpdated('MAIL', value);
        }
      },


      nom: {
        get(): string {
          return this.editSalarie.nom;
        },
        set(value: string) {
          this.editSalarie.nom = value;
          this.fieldUpdated('NOM', value);
        }
      },


      nomNaissance: {
        get(): string {
          return this.editSalarie.nomNaissance;
        },
        set(value: string) {
          this.editSalarie.nomNaissance = value;
          this.fieldUpdated('NOM_NAISSANCE', value);
        }
      },


      numero: {
        get(): string {
          return this.editSalarie.numero;
        },
        set(value: string) {
          this.editSalarie.numero = value;
          this.fieldUpdated('NUMERO', value);
        }
      },


      numeroCongeSpec: {
        get(): string {
          return this.editSalarie.numeroCongeSpec;
        },
        set(value: string) {
          this.editSalarie.numeroCongeSpec = value;
          this.fieldUpdated('NUMERO_CONGE_SPEC', value);
        }
      },


      numeroSecu: {
        get(): string | null {
          return this.editSalarie.numeroSecu;
        },
        set(value: string | null) {
          this.editSalarie.numeroSecu = value;
          this.fieldUpdated('NUMERO_SECU', value);
        }
      },


      prenom: {
        get(): string {
          return this.editSalarie.prenom;
        },
        set(value: string) {
          this.editSalarie.prenom = value;
          this.fieldUpdated('PRENOM', value);
        }
      },


      pseudo: {
        get(): string {
          return this.editSalarie.pseudo;
        },
        set(value: string) {
          this.editSalarie.pseudo = value;
          this.fieldUpdated('PSEUDO', value);
        }
      },


      statutHandicap: {
        get(): number {
          return this.editSalarie.statutHandicap;
        },
        set(value: number) {
          this.editSalarie.statutHandicap = value;
          this.fieldUpdated('STATUT_HANDICAP', value);
        }
      },


      villeNaissance: {
        get(): string {
          return this.editSalarie.villeNaissance;
        },
        set(value: string) {
          this.editSalarie.villeNaissance = value;
          this.fieldUpdated('VILLE_NAISSANCE', value);
        }
      },


      allReadOnly (): boolean {
        const res = this.salarie.canUpdate && (
        (this.isDisplayed('CIVILITE_ID') && !this.readOnly('CIVILITE_ID')) ||
        (this.isDisplayed('EMPLOI_ID') && !this.readOnly('EMPLOI_ID')) ||
        (this.isDisplayed('PAYS_NAISSANCE_ID') && !this.readOnly('PAYS_NAISSANCE_ID')) ||
        (this.isDisplayed('PAYS_NATIONALITE_ID') && !this.readOnly('PAYS_NATIONALITE_ID')) ||
        (this.isDisplayed('ABATTEMENT') && !this.readOnly('ABATTEMENT')) ||
        (this.isDisplayed('AVATAR') && !this.readOnly('AVATAR')) ||
        (this.isDisplayed('DATE_HANDICAP') && !this.readOnly('DATE_HANDICAP')) ||
        (this.isDisplayed('DATE_NAISSANCE') && !this.readOnly('DATE_NAISSANCE')) ||
        (this.isDisplayed('DEPARTEMENT_NAISSANCE') && !this.readOnly('DEPARTEMENT_NAISSANCE')) ||
        (this.isDisplayed('FISCALITE') && !this.readOnly('FISCALITE')) ||
        (this.isDisplayed('IDENTIFIANT') && !this.readOnly('IDENTIFIANT')) ||
        (this.isDisplayed('MAIL') && !this.readOnly('MAIL')) ||
        (this.isDisplayed('NOM') && !this.readOnly('NOM')) ||
        (this.isDisplayed('NOM_NAISSANCE') && !this.readOnly('NOM_NAISSANCE')) ||
        (this.isDisplayed('NUMERO') && !this.readOnly('NUMERO')) ||
        (this.isDisplayed('NUMERO_CONGE_SPEC') && !this.readOnly('NUMERO_CONGE_SPEC')) ||
        (this.isDisplayed('NUMERO_SECU') && !this.readOnly('NUMERO_SECU')) ||
        (this.isDisplayed('PRENOM') && !this.readOnly('PRENOM')) ||
        (this.isDisplayed('PSEUDO') && !this.readOnly('PSEUDO')) ||
        (this.isDisplayed('STATUT_HANDICAP') && !this.readOnly('STATUT_HANDICAP')) ||
        (this.isDisplayed('VILLE_NAISSANCE') && !this.readOnly('VILLE_NAISSANCE')));
        return !res;
      },

      fields (): string[] {
        return ['CIVILITE_ID', 'EMPLOI_ID', 'PAYS_NAISSANCE_ID', 'PAYS_NATIONALITE_ID', 'ABATTEMENT', 'AVATAR', 'DATE_HANDICAP', 'DATE_NAISSANCE', 'DEPARTEMENT_NAISSANCE', 'FISCALITE', 'IDENTIFIANT', 'MAIL', 'NOM', 'NOM_NAISSANCE', 'NUMERO', 'NUMERO_CONGE_SPEC', 'NUMERO_SECU', 'PRENOM', 'PSEUDO', 'STATUT_HANDICAP', 'VILLE_NAISSANCE'];
      },
    },

    methods: {
      handleSalarieChange() : void {
        // Edited object changed
        this.saveFailed = false;
        if (this.autoSave && this.updatedAndValid) {
          if (!this.inDialog && this.checkFields()) {
            // Dialogue to save or cancel changes
            this.inDialog = true;
            this.dialogSaveOrCancel().then(() => {
              this.createRef(this.salarie);
              this.inDialog = false;
                  })
          } else if (!this.restoring && !this.inDialog) {
            this.restoreEdited();
            this.createRef(this.salarie);
          }
        } else if (!this.inDialog) {
          if (this.cloneSalarie.id < 0) {
            this.clearRef();
          } else if (this.updated) {
            this.restoreEdited();
          }
          this.createRef(this.salarie);
        }
      },
      beforeClose (): void {
        if (!this.closing) {
          this.closing = true;
          if (this.autoSave && this.updatedAndValid && this.checkFields()) {
            this.$emit('saveOrCancel');
            this.dialogSaveOrCancel();
          } else {
            if (this.autoSave && this.updated) {
              this.restoreEdited();
            }
            this.$emit('cancelled');
          }
          this.clearRef();
          }
      },

      setExtended (extended: Extended): void {
         this.$emit('extended', extended);
      },

      // eslint-disable-next-line
      isDisplayed (value: string): boolean {
        return true;
      },

      // eslint-disable-next-line
      required (value: string): boolean {
        return false;
      },

      // eslint-disable-next-line
      readOnly (value: string): boolean {
        return false;
      },

      save (): void {
        if (event != undefined) {
          event.stopPropagation();
        }
        this.saveLoading = true;
        this.saveFailed = false;
        if (this.checkFields()) {
          this.saveObj();
        } else {
        this.saveLoading = false;
          this.saveFailed = true;
        }
      },

      setUpdated (): void {
        const updated = (this.civiliteIdStatus != undefined && this.civiliteIdStatus.updated) ||
          (this.emploiIdStatus != undefined && this.emploiIdStatus.updated) ||
          (this.paysNaissanceIdStatus != undefined && this.paysNaissanceIdStatus.updated) ||
          (this.paysNationaliteIdStatus != undefined && this.paysNationaliteIdStatus.updated) ||
          (this.abattementStatus != undefined && this.abattementStatus.updated) ||
          (this.avatarStatus != undefined && this.avatarStatus.updated) ||
          (this.dateHandicapStatus != undefined && this.dateHandicapStatus.updated) ||
          (this.dateNaissanceStatus != undefined && this.dateNaissanceStatus.updated) ||
          (this.departementNaissanceStatus != undefined && this.departementNaissanceStatus.updated) ||
          (this.fiscaliteStatus != undefined && this.fiscaliteStatus.updated) ||
          (this.identifiantStatus != undefined && this.identifiantStatus.updated) ||
          (this.mailStatus != undefined && this.mailStatus.updated) ||
          (this.nomStatus != undefined && this.nomStatus.updated) ||
          (this.nomNaissanceStatus != undefined && this.nomNaissanceStatus.updated) ||
          (this.numeroStatus != undefined && this.numeroStatus.updated) ||
          (this.numeroCongeSpecStatus != undefined && this.numeroCongeSpecStatus.updated) ||
          (this.numeroSecuStatus != undefined && this.numeroSecuStatus.updated) ||
          (this.prenomStatus != undefined && this.prenomStatus.updated) ||
          (this.pseudoStatus != undefined && this.pseudoStatus.updated) ||
          (this.statutHandicapStatus != undefined && this.statutHandicapStatus.updated) ||
          (this.villeNaissanceStatus != undefined && this.villeNaissanceStatus.updated);
        if (updated != this.updated) {
          this.updated = updated;
          this.status.updated = updated;
          this.status.missing = this.hasMissing();
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.salarie);
        }
      },

      setError (): void {
        const error = this.civiliteIdStatus.error ||
        this.emploiIdStatus.error ||
        this.paysNaissanceIdStatus.error ||
        this.paysNationaliteIdStatus.error ||
        this.abattementStatus.error ||
        this.avatarStatus.error ||
        this.dateHandicapStatus.error ||
        this.dateNaissanceStatus.error ||
        this.departementNaissanceStatus.error ||
        this.fiscaliteStatus.error ||
        this.identifiantStatus.error ||
        this.mailStatus.error ||
        this.nomStatus.error ||
        this.nomNaissanceStatus.error ||
        this.numeroStatus.error ||
        this.numeroCongeSpecStatus.error ||
        this.numeroSecuStatus.error ||
        this.prenomStatus.error ||
        this.pseudoStatus.error ||
        this.statutHandicapStatus.error ||
        this.villeNaissanceStatus.error;
        if (error != this.error) {
          if (!error) {
            this.saveFailed = false;
          }
          this.error = error;
          this.status.error = error;
          if (!this.closing) {
            this.$emit('status', this.status);
          }
          this.$emit('updated', this.salarie);
        }
      },

      // Clear non saved new objects when leaving
      clearRef (): void {
        if (this.clearAuto && this.refSalarie.id < 0) {
          storeSalarie.mSalarieDeleted(this.refSalarie.id);
        }
      },

      // Dialog to save or ignore changes when loosing focus or changing edited item
      dialogSaveOrCancel (): Promise<boolean> {
        return new Promise((resolve) => {
          if (!this.error) {
            Alerts.saveOrCancel()
              .then((result: boolean) => {
                if (result) {
                  this.saveObj();
                } else {
                  if (this.refSalarie.id <= 0) {
                    this.deleteObj();
                  } else {
                    this.restoreEdited();
                  }
                  this.$emit('cancelled');
                }
                resolve(result);
              })
          } else {
            this.restoreEdited();
          }
        })
      },

      // Save object and subobjects referenced by foreignClass keys
      saveObj (): void {
        this.saving = true;
        if (
          this.saveSalarie()
          ) {
          this.saving = false;
          this.saveLoading = false;
          this.salarieSaving = false;
          this.createRef(this.refSalarie);
          this.$emit('updated', this.refSalarie);
          if (this.salarie.id > 0) {
            this.$emit('saved', this.refSalarie);
          } else {
            this.updated = true;
          }
          if (this.autoClose) {
            this.saveFields();
            this.$emit('closeDialog');
          }
        } else {
          if (this.refSalarie.failed) {
          this.saveLoading = false;
            this.salarieSaving = false;
            this.refSalarie.failed = false;
          }
        }
      },

      saveSalarie (): boolean {
        if (!this.refSalarie.compareSalarie(this.cloneSalarie)) {
          if (!this.salarieSaving) {
            this.salarieSaving = true;
          if (this.refSalarie.id > 0) {
            storeSalarie.updateSalarie(this.refSalarie)
              .then((data: Salarie) => {
                if (!data.failed) {
                  this.refSalarie = storeSalarie.getSalarie(data.id);
                  this.cloneSalarie = data.cloneSalarie();
                } else {
                  this.refSalarie.failed = true;
                }
                this.saveObj();
              })
              .catch(() => {
                this.restoreEdited();
                this.salarieSaving = false;
                this.saveLoading = false;
              })
          }
            if (this.refSalarie.id <= 0) {
              storeSalarie.createSalarie(this.refSalarie)
                .then((data: Salarie) => {
                  if (!data.failed) {
                    this.refSalarie = storeSalarie.getSalarie(data.id);
                    this.cloneSalarie = data.cloneSalarie();
                  } else {
                this.refSalarie.failed = true;
                  }
                  this.saveObj();
                })
                .catch(() => {
                  this.restoreEdited();
                    this.salarieSaving = false;
                })
            }
          }
          return false;
        } else {
          return true;
        }
      },

      // Delete object
      deleteObj (): void {
        if (this.refSalarie.id <= 0) {
          storeSalarie.mSalarieDeleted(this.refSalarie.id);
        } else {
          storeSalarie.deleteSalarie(this.refSalarie);
        }
      },

      statusCiviliteId (value: FieldStatus): void {
        this.civiliteIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusEmploiId (value: FieldStatus): void {
        this.emploiIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPaysNaissanceId (value: FieldStatus): void {
        this.paysNaissanceIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPaysNationaliteId (value: FieldStatus): void {
        this.paysNationaliteIdStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAbattement (value: FieldStatus): void {
        this.abattementStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusAvatar (value: FieldStatus): void {
        this.avatarStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateHandicap (value: FieldStatus): void {
        this.dateHandicapStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDateNaissance (value: FieldStatus): void {
        this.dateNaissanceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusDepartementNaissance (value: FieldStatus): void {
        this.departementNaissanceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusFiscalite (value: FieldStatus): void {
        this.fiscaliteStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusIdentifiant (value: FieldStatus): void {
        this.identifiantStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusMail (value: FieldStatus): void {
        this.mailStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNom (value: FieldStatus): void {
        this.nomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNomNaissance (value: FieldStatus): void {
        this.nomNaissanceStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumero (value: FieldStatus): void {
        this.numeroStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumeroCongeSpec (value: FieldStatus): void {
        this.numeroCongeSpecStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusNumeroSecu (value: FieldStatus): void {
        this.numeroSecuStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPrenom (value: FieldStatus): void {
        this.prenomStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusPseudo (value: FieldStatus): void {
        this.pseudoStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusStatutHandicap (value: FieldStatus): void {
        this.statutHandicapStatus = value;
        this.setUpdated();
        this.setError();
      },
      statusVilleNaissance (value: FieldStatus): void {
        this.villeNaissanceStatus = value;
        this.setUpdated();
        this.setError();
      },

      deleteSalarie(): void {
        this.$emit('deleteSalarie',  this.salarie);
      },

    addSalarie(): void {
      this.$emit('addSalarie',  this.salarie);
    },

      // Restore object
      restoreEdited (): void {
        if (this.cloneSalarie != undefined) {
          this.restoring = true;
          this.refSalarie.civiliteId = this.cloneSalarie.civiliteId;
          this.refSalarie.emploiId = this.cloneSalarie.emploiId;
          this.refSalarie.paysNaissanceId = this.cloneSalarie.paysNaissanceId;
          this.refSalarie.paysNationaliteId = this.cloneSalarie.paysNationaliteId;
          this.refSalarie.abattement = this.cloneSalarie.abattement;
          this.refSalarie.avatar = this.cloneSalarie.avatar;
          this.refSalarie.dateHandicap = this.cloneSalarie.dateHandicap;
          this.refSalarie.dateNaissance = this.cloneSalarie.dateNaissance;
          this.refSalarie.departementNaissance = this.cloneSalarie.departementNaissance;
          this.refSalarie.fiscalite = this.cloneSalarie.fiscalite;
          this.refSalarie.identifiant = this.cloneSalarie.identifiant;
          this.refSalarie.mail = this.cloneSalarie.mail;
          this.refSalarie.nom = this.cloneSalarie.nom;
          this.refSalarie.nomNaissance = this.cloneSalarie.nomNaissance;
          this.refSalarie.numero = this.cloneSalarie.numero;
          this.refSalarie.numeroCongeSpec = this.cloneSalarie.numeroCongeSpec;
          this.refSalarie.numeroSecu = this.cloneSalarie.numeroSecu;
          this.refSalarie.prenom = this.cloneSalarie.prenom;
          this.refSalarie.pseudo = this.cloneSalarie.pseudo;
          this.refSalarie.statutHandicap = this.cloneSalarie.statutHandicap;
          this.refSalarie.villeNaissance = this.cloneSalarie.villeNaissance;
          this.restoring = false;
        }
      },


    // Clone and clear edited
      createRef (value: Salarie): void {
        this.clearRef();
        this.editSalarie = value;
        this.cloneSalarie = value.cloneSalarie();
        this.civiliteIdStatus.clear(value.id);
        this.emploiIdStatus.clear(value.id);
        this.paysNaissanceIdStatus.clear(value.id);
        this.paysNationaliteIdStatus.clear(value.id);
        this.abattementStatus.clear(value.id);
        this.avatarStatus.clear(value.id);
        this.dateHandicapStatus.clear(value.id);
        this.dateNaissanceStatus.clear(value.id);
        this.departementNaissanceStatus.clear(value.id);
        this.fiscaliteStatus.clear(value.id);
        this.identifiantStatus.clear(value.id);
        this.mailStatus.clear(value.id);
        this.nomStatus.clear(value.id);
        this.nomNaissanceStatus.clear(value.id);
        this.numeroStatus.clear(value.id);
        this.numeroCongeSpecStatus.clear(value.id);
        this.numeroSecuStatus.clear(value.id);
        this.prenomStatus.clear(value.id);
        this.pseudoStatus.clear(value.id);
        this.statutHandicapStatus.clear(value.id);
        this.villeNaissanceStatus.clear(value.id);
        this.status.clear();
      },

    checkFields (): boolean {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID) this.$refs.EMPLOI_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_NAISSANCE_ID') && this.$refs.PAYS_NAISSANCE_ID) this.$refs.PAYS_NAISSANCE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_NATIONALITE_ID') && this.$refs.PAYS_NATIONALITE_ID) this.$refs.PAYS_NATIONALITE_ID.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ABATTEMENT') && this.$refs.ABATTEMENT) this.$refs.ABATTEMENT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AVATAR') && this.$refs.AVATAR) this.$refs.AVATAR.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_HANDICAP') && this.$refs.DATE_HANDICAP) this.$refs.DATE_HANDICAP.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_NAISSANCE') && this.$refs.DATE_NAISSANCE) this.$refs.DATE_NAISSANCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DEPARTEMENT_NAISSANCE') && this.$refs.DEPARTEMENT_NAISSANCE) this.$refs.DEPARTEMENT_NAISSANCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FISCALITE') && this.$refs.FISCALITE) this.$refs.FISCALITE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT) this.$refs.IDENTIFIANT.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM_NAISSANCE') && this.$refs.NOM_NAISSANCE) this.$refs.NOM_NAISSANCE.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO_CONGE_SPEC') && this.$refs.NUMERO_CONGE_SPEC) this.$refs.NUMERO_CONGE_SPEC.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO_SECU') && this.$refs.NUMERO_SECU) this.$refs.NUMERO_SECU.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PSEUDO') && this.$refs.PSEUDO) this.$refs.PSEUDO.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT_HANDICAP') && this.$refs.STATUT_HANDICAP) this.$refs.STATUT_HANDICAP.touch();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE_NAISSANCE') && this.$refs.VILLE_NAISSANCE) this.$refs.VILLE_NAISSANCE.touch();
        return !this.error;
      },

      missing (value: string): boolean {
        return this.hasMissing(value);
      },

      hasMissing (value = ''): boolean {
        let missing = false;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'CIVILITE_ID') && this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID && this.$refs.CIVILITE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'EMPLOI_ID') && this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID && this.$refs.EMPLOI_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PAYS_NAISSANCE_ID') && this.isDisplayed('PAYS_NAISSANCE_ID') && this.$refs.PAYS_NAISSANCE_ID && this.$refs.PAYS_NAISSANCE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PAYS_NATIONALITE_ID') && this.isDisplayed('PAYS_NATIONALITE_ID') && this.$refs.PAYS_NATIONALITE_ID && this.$refs.PAYS_NATIONALITE_ID.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'ABATTEMENT') && this.isDisplayed('ABATTEMENT') && this.$refs.ABATTEMENT && this.$refs.ABATTEMENT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'AVATAR') && this.isDisplayed('AVATAR') && this.$refs.AVATAR && this.$refs.AVATAR.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_HANDICAP') && this.isDisplayed('DATE_HANDICAP') && this.$refs.DATE_HANDICAP && this.$refs.DATE_HANDICAP.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DATE_NAISSANCE') && this.isDisplayed('DATE_NAISSANCE') && this.$refs.DATE_NAISSANCE && this.$refs.DATE_NAISSANCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'DEPARTEMENT_NAISSANCE') && this.isDisplayed('DEPARTEMENT_NAISSANCE') && this.$refs.DEPARTEMENT_NAISSANCE && this.$refs.DEPARTEMENT_NAISSANCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'FISCALITE') && this.isDisplayed('FISCALITE') && this.$refs.FISCALITE && this.$refs.FISCALITE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'IDENTIFIANT') && this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT && this.$refs.IDENTIFIANT.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'MAIL') && this.isDisplayed('MAIL') && this.$refs.MAIL && this.$refs.MAIL.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM') && this.isDisplayed('NOM') && this.$refs.NOM && this.$refs.NOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NOM_NAISSANCE') && this.isDisplayed('NOM_NAISSANCE') && this.$refs.NOM_NAISSANCE && this.$refs.NOM_NAISSANCE.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO') && this.isDisplayed('NUMERO') && this.$refs.NUMERO && this.$refs.NUMERO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO_CONGE_SPEC') && this.isDisplayed('NUMERO_CONGE_SPEC') && this.$refs.NUMERO_CONGE_SPEC && this.$refs.NUMERO_CONGE_SPEC.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'NUMERO_SECU') && this.isDisplayed('NUMERO_SECU') && this.$refs.NUMERO_SECU && this.$refs.NUMERO_SECU.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PRENOM') && this.isDisplayed('PRENOM') && this.$refs.PRENOM && this.$refs.PRENOM.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'PSEUDO') && this.isDisplayed('PSEUDO') && this.$refs.PSEUDO && this.$refs.PSEUDO.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'STATUT_HANDICAP') && this.isDisplayed('STATUT_HANDICAP') && this.$refs.STATUT_HANDICAP && this.$refs.STATUT_HANDICAP.missing()) missing = true;
        // @ts-expect-error : generated method
        if ((value == '' || value == 'VILLE_NAISSANCE') && this.isDisplayed('VILLE_NAISSANCE') && this.$refs.VILLE_NAISSANCE && this.$refs.VILLE_NAISSANCE.missing()) missing = true;
        return missing;
      },

      saveFields (): void {
        // @ts-expect-error : generated method
        if (this.isDisplayed('CIVILITE_ID') && this.$refs.CIVILITE_ID) this.$refs.CIVILITE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('EMPLOI_ID') && this.$refs.EMPLOI_ID) this.$refs.EMPLOI_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_NAISSANCE_ID') && this.$refs.PAYS_NAISSANCE_ID) this.$refs.PAYS_NAISSANCE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PAYS_NATIONALITE_ID') && this.$refs.PAYS_NATIONALITE_ID) this.$refs.PAYS_NATIONALITE_ID.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('ABATTEMENT') && this.$refs.ABATTEMENT) this.$refs.ABATTEMENT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('AVATAR') && this.$refs.AVATAR) this.$refs.AVATAR.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_HANDICAP') && this.$refs.DATE_HANDICAP) this.$refs.DATE_HANDICAP.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DATE_NAISSANCE') && this.$refs.DATE_NAISSANCE) this.$refs.DATE_NAISSANCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('DEPARTEMENT_NAISSANCE') && this.$refs.DEPARTEMENT_NAISSANCE) this.$refs.DEPARTEMENT_NAISSANCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('FISCALITE') && this.$refs.FISCALITE) this.$refs.FISCALITE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('IDENTIFIANT') && this.$refs.IDENTIFIANT) this.$refs.IDENTIFIANT.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('MAIL') && this.$refs.MAIL) this.$refs.MAIL.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM') && this.$refs.NOM) this.$refs.NOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NOM_NAISSANCE') && this.$refs.NOM_NAISSANCE) this.$refs.NOM_NAISSANCE.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO') && this.$refs.NUMERO) this.$refs.NUMERO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO_CONGE_SPEC') && this.$refs.NUMERO_CONGE_SPEC) this.$refs.NUMERO_CONGE_SPEC.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('NUMERO_SECU') && this.$refs.NUMERO_SECU) this.$refs.NUMERO_SECU.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PRENOM') && this.$refs.PRENOM) this.$refs.PRENOM.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('PSEUDO') && this.$refs.PSEUDO) this.$refs.PSEUDO.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('STATUT_HANDICAP') && this.$refs.STATUT_HANDICAP) this.$refs.STATUT_HANDICAP.save();
        // @ts-expect-error : generated method
        if (this.isDisplayed('VILLE_NAISSANCE') && this.$refs.VILLE_NAISSANCE) this.$refs.VILLE_NAISSANCE.save();
      },

      getValue (field: string): string {
         if (field == 'CIVILITE_ID') return this.civiliteId.toString();
        else  if (field == 'EMPLOI_ID') return this.emploiId.toString();
        else  if (field == 'PAYS_NAISSANCE_ID') return this.paysNaissanceId.toString();
        else  if (field == 'PAYS_NATIONALITE_ID') return this.paysNationaliteId.toString();
        else  if (field == 'ABATTEMENT') return this.abattement == null ? '' : this.abattement.toString();
        else  if (field == 'AVATAR') return this.avatar.toString();
        else  if (field == 'DATE_HANDICAP') return this.dateHandicap == null ? '' : this.dateHandicap.toString();
        else  if (field == 'DATE_NAISSANCE') return this.dateNaissance == null ? '' : this.dateNaissance.toString();
        else  if (field == 'DEPARTEMENT_NAISSANCE') return this.departementNaissance.toString();
        else  if (field == 'FISCALITE') return this.fiscalite.toString();
        else  if (field == 'IDENTIFIANT') return this.identifiant.toString();
        else  if (field == 'MAIL') return this.mail.toString();
        else  if (field == 'NOM') return this.nom.toString();
        else  if (field == 'NOM_NAISSANCE') return this.nomNaissance.toString();
        else  if (field == 'NUMERO') return this.numero.toString();
        else  if (field == 'NUMERO_CONGE_SPEC') return this.numeroCongeSpec.toString();
        else  if (field == 'NUMERO_SECU') return this.numeroSecu == null ? '' : this.numeroSecu.toString();
        else  if (field == 'PRENOM') return this.prenom.toString();
        else  if (field == 'PSEUDO') return this.pseudo.toString();
        else  if (field == 'STATUT_HANDICAP') return this.statutHandicap.toString();
        else  if (field == 'VILLE_NAISSANCE') return this.villeNaissance.toString();
        else return '';
      },

    // eslint-disable-next-line
    fieldUpdated (field: string, value: unknown): void {
      // To implement
    },

      setFocus (route: Route): boolean {
        let res = false;
        let first = '';
        const attribut = route ? route.attribut : '';
        this.fields.forEach(field => {
          // @ts-expect-error : generated method
          if (!res && this.isDisplayed(field) && !this.readOnly(field) && this.$refs[field].setFocus) {
            if (attribut == field) {
              // @ts-expect-error : generated method
              this.$refs[attribut].setFocus();
              res = true;
            } else if (first == '') {
              first = field;
            }
          }
        })
        // @ts-expect-error : generated method
        if (!res && first != '' && this.$refs[first] && this.$refs[first].setFocus) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus();
          res = true;
        }
        return res
      },

      closeDialog(): void {
        this.$emit('closeDialog')
      }
    },
  })
